import { LocationNumbersService } from '../../../services'

const fetchPhoneNumbersA2PStatus = async function (
  { commit, state, getters },
  config
) {
  const { companyId, locationId } = config
  try {
    // check if linkedNumbers response is already fetched
    let response;
    if (state.linkedNumbers && state.linkedNumbers?.linkedNumbers?.length) {
      response = state.linkedNumbers
    } else {
      const { data } = await LocationNumbersService.getA2PStatus(companyId, locationId)
      response = data
    }


    commit('setLinkedNumbers', response)
    commit('setPhoneNumbersA2PLookup', response)

    const result = response?.linkedNumbers
    return Promise.resolve(result)
  } catch (error) {
    return Promise.reject(error)
  }

}

export default fetchPhoneNumbersA2PStatus
